module.exports = __webpack_public_path__ + "static/media/unpeeled_tomatoes.f1c87367.png";